import { req } from "./transport";
import type { WorkTarget } from "./workReports";

export type EarlierEntry = { id: string; byUserId: number; byRole: string; authorName: string | null; note: string; createdAt: string };
export type EarlierTimeLog = { id: string; userId: number; authorName: string | null; clockIn: string; clockOut: string | null; minutes: number | null; note: string | null };
export type WorkHistory = {
  canWrite: boolean; readOnlyReason: string | null;
  legacy: { checkins: EarlierEntry[]; progress: (EarlierEntry & { logType: string })[]; timeLogs: EarlierTimeLog[] };
  completionSnapshot: unknown;
};
export const workHistoryApi = {
  workHistory(target: WorkTarget) {
    return req<WorkHistory>(`/${target.kind === "contract" ? "contracts" : "engagements"}/${encodeURIComponent(target.id)}/work/history`, {}, { rejectUnauthorized: true });
  },
};
